export default __webpack_public_path__ + "static/media/check.52eca41b.svg";